import React, { useEffect, createElement } from 'react';
import { CheckCircle, Users } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LlamadaAiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    // Pixel base + init + PageView handled globally in App.tsx — fire only
    // this page's unique event to avoid double-counting.
    if (window.fbq) {
      window.fbq('trackCustom', 'Book-Call-PV');
    }
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const wistiaEmbedScript = document.createElement('script');
    wistiaEmbedScript.src = 'https://fast.wistia.com/embed/1n1c7tnsqb.js';
    wistiaEmbedScript.async = true;
    wistiaEmbedScript.type = 'module';
    document.head.appendChild(wistiaEmbedScript);
    const wistiaStyle = document.createElement('style');
    wistiaStyle.textContent = `wistia-player[media-id='1n1c7tnsqb']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1n1c7tnsqb/swatch'); display: block; filter: blur(5px); padding-top:56.25%; }`;
    document.head.appendChild(wistiaStyle);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(wistiaEmbedScript);
      document.head.removeChild(wistiaStyle);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-3071" data-mp="1wxmu5p4wryzi">
      {/* Hero Section */}
      <section className="pt-6 md:pt-20 pb-12 md:pb-16 bg-gradient-to-b from-gray-900 to-black" data-id="element-3072" data-mp="21vy2fvfk21fm">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-3073" data-mp="1mz75dstct1t6">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-6 leading-tight text-center tracking-tight" data-id="element-3074" data-mp="1rytdjnubrrv4">
            Agenda Tu Llamada de Claridad
          </h1>

          {/* Wistia Video */}
          <div className="mb-8 rounded-2xl overflow-hidden border-2 border-cyan-500 shadow-2xl" data-id="element-3075" data-mp="1ixll3mehpl8y">
            <wistia-player media-id="1n1c7tnsqb" aspect="1.7777777777777777" data-id="element-3076" data-mp="38d1soxcrmywq"></wistia-player>
          </div>

          {/* Qualification Message */}
          <div className="bg-gradient-to-r from-cyan-900 to-blue-900 rounded-2xl p-6 md:p-8 border-2 border-cyan-500 mb-8 shadow-2xl" data-id="element-3077" data-mp="3dabnksixc2ry">
            <div className="flex items-start gap-4 mb-4" data-id="element-3078" data-mp="3ihrwz9vn6f44">
              <CheckCircle className="w-6 h-6 md:w-7 md:h-7 text-cyan-400 flex-shrink-0 mt-1" data-id="element-3079" data-mp="3if5fahf1ej86" />
              <div data-id="element-3080" data-mp="4k3x6iicz01">
                <h2 className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-3081" data-mp="3rhy7qnzyh0zl">
                  Proceso de Calificación
                </h2>
                <p className="text-base md:text-lg text-gray-100 leading-relaxed" data-id="element-3082" data-mp="a0dnh9un9srb">
                  Para poder hablar con nuestro equipo, primero debemos
                  verificar si eres un buen candidato para esta oportunidad. Por
                  favor, completa el formulario a continuación para agendar tu
                  llamada de claridad.
                </p>
              </div>
            </div>
          </div>

          {/* Benefits List */}
          <div className="bg-gray-800/50 rounded-xl p-6 md:p-8 border border-gray-700 mb-10" data-id="element-3083" data-mp="2grwaand2y8s9">
            <h3 className="text-lg md:text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-3084" data-mp="2gu8xbexp39c6">
              <Users className="w-6 h-6 text-cyan-400" data-id="element-3085" data-mp="2ibeh178e9u16" />
              En esta llamada descubrirás:
            </h3>
            <div className="space-y-3" data-id="element-3086" data-mp="2r9zvaq6u2mw5">
              {['Si 48/hrs AI Cash Machine es adecuado para tu situación actual', 'Cómo implementar el sistema paso a paso en tu negocio', 'Estrategias personalizadas para tu nicho específico', 'Respuestas a todas tus preguntas sobre el programa'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-3087" data-mp="23k5k0d25x6e0" data-mpi={i}>
                  <CheckCircle className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-3088" data-mp="23kf81v3nd3h2" />
                  <span className="text-gray-200 text-sm md:text-base" data-id="element-3089" data-mp="28hp8s6whl1k7">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-12 md:py-16 bg-gradient-to-b from-black to-gray-900" data-id="element-3090" data-mp="1ktec7fxtpo1q">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-3091" data-mp="1krbe08mioolx">
          <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-6 md:p-8 border border-gray-700" data-id="element-3092" data-mp="1d8u1dtjcgtoq">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4 text-center" data-id="element-3093" data-mp="18bv4j38aq8mu">
              ¿Qué Esperar de la Llamada?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-3094" data-mp="zawzchm4fv2o">
              <div className="space-y-3" data-id="element-3095" data-mp="zcgh6cnfee6k">
                <div className="flex items-start gap-3" data-id="element-3096" data-mp="ubsto0yeofh3">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-3097" data-mp="uddlvjx8zmbs">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-3098" data-mp="pizq3geobd6l" />
                  </div>
                  <div data-id="element-3099" data-mp="km0usuj9x06t">
                    <p className="font-semibold text-white text-sm" data-id="element-3100" data-mp="kjeqd3roj0st">
                      Duración: 30-45 minutos
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-3101" data-mp="blb1bxhhjlw9">
                      Tiempo suficiente para conocerte
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-3102" data-mp="3t3i3hsbeqv66">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-3103" data-mp="3t1x860h9r879">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-3104" data-mp="10h4p4ktbu5r" />
                  </div>
                  <div data-id="element-3105" data-mp="3j6c8i8zoak0o">
                    <p className="font-semibold text-white text-sm" data-id="element-3106" data-mp="3j7588q07s99b">
                      Formato: Video llamada
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-3107" data-mp="folsuo2mwxvx">
                      Conexión personal y directa
                    </p>
                  </div>
                </div>
              </div>
              <div className="space-y-3" data-id="element-3108" data-mp="5ysczavglwlv">
                <div className="flex items-start gap-3" data-id="element-3109" data-mp="5xqzkzqz0y0z">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-3110" data-mp="axvhmu7j20tb">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-3111" data-mp="avis9vzfwo68" />
                  </div>
                  <div data-id="element-3112" data-mp="yld6ohzeqksl">
                    <p className="font-semibold text-white text-sm" data-id="element-3113" data-mp="13dwib9ejb5ur">
                      Sin presión de venta
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-3114" data-mp="2o3jv0d5c68bf">
                      Solo asesoría honesta
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-3115" data-mp="2wwnb6t7d8z9r">
                  <div className="bg-cyan-500/20 rounded-full p-2 flex-shrink-0" data-id="element-3116" data-mp="2ww3xxpsnuz22">
                    <CheckCircle className="w-4 h-4 text-cyan-400" data-id="element-3117" data-mp="2svtqs9t4u2lm" />
                  </div>
                  <div data-id="element-3118" data-mp="256imwjghjs39">
                    <p className="font-semibold text-white text-sm" data-id="element-3119" data-mp="257tnybijqlqo">
                      Plan personalizado
                    </p>
                    <p className="text-gray-300 text-xs" data-id="element-3120" data-mp="2e65q9asrz7yy">
                      Adaptado a tu situación
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-3121" data-mp="3pjzrilmxoaum" />
      <WhatsAppButton data-id="element-3122" data-mp="3pnnj3f8tin6p" />
    </div>;
}